"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeType_1 = require("../enums/ChallengeType");
const userTelemetry_1 = require("../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'registration',
    props: {},
    computed: {
        currentChallengeType() {
            const challengeType = this.$store.getters.currentChallengeType;
            switch (challengeType) {
                case ChallengeType_1.ChallengeType.StepUp:
                    return ChallengeType_1.ChallengeType.StepUpForgot;
                case ChallengeType_1.ChallengeType.OneTimeCode:
                    return ChallengeType_1.ChallengeType.OneTimeCodeForgotContainer;
                case ChallengeType_1.ChallengeType.CheckSyncResult:
                    return ChallengeType_1.ChallengeType.CheckSyncResultForgot;
                default:
                    return challengeType;
            }
        },
        authenticatedModel() {
            return this.$store.getters.authenticatedModel;
        },
        isSyncing() {
            return this.$store.getters.isSyncing;
        },
    },
    watch: {
        authenticatedModel(newAuthenticationModel) {
            if (newAuthenticationModel && typeof newAuthenticationModel.username == 'string' && typeof newAuthenticationModel.nonce == 'string') {
                this.$nextTick(() => {
                    const formElement = document.querySelector('#form_authenticated');
                    if (formElement) {
                        this.$store.commit('setIsSubmittingAuthenticatedModel', true);
                        formElement.submit();
                    }
                });
            }
        },
        async isSyncing() {
            while (this.$store.getters.isSyncing) {
                const challenge = { ...this.$store.getters.checkSyncResultChallenge };
                await this.$store.dispatch('submitChallenge', challenge);
                await new Promise(r => setTimeout(r, 1000));
            }
        },
    },
    components: {},
    mounted() {
        this.$store.commit('currentChallenge', {
            ChallengeTypeValue: this.$store.getters.configuration.initialChallengeType,
            Progression: [],
        });
        void this.$store.dispatch('submitChallenge', this.$store.state.currentChallenge);
        void userTelemetry_1.telemetry.page(userTelemetry_1.workflowName.retail_registration);
    },
});
